const SHAPEFILE_PREFIX = "Shapefile_";

export interface ParsedShapefileProperty {
  projectId: string;
  shapefileId: string;
  /** Decoded attribute/column name (base64-encoded in the property key). */
  columnName: string;
}

/**
 * Parses a shapefile field property key of the shape
 * `Shapefile_{projectId}_{shapefileId}_{btoa(columnName)}` (see
 * ShapefileCategory.onSelectShapefile). GUIDs and standard base64 contain no
 * underscore, so the first two segments are the ids and the rest is the
 * encoded column name. Returns null for non-shapefile keys.
 */
export const parseShapefileProperty = (
  property: string
): Nullable<ParsedShapefileProperty> => {
  if (!property?.startsWith(SHAPEFILE_PREFIX)) return null;
  const parts = property.slice(SHAPEFILE_PREFIX.length).split("_");
  if (parts.length < 3) return null;
  const [projectId, shapefileId, ...encoded] = parts;
  let columnName = encoded.join("_");
  try {
    columnName = atob(columnName);
  } catch {
    // ponytail: leave the raw segment if it isn't valid base64
  }
  return { projectId, shapefileId, columnName };
};
